import { NgModule } from '@angular/core';
import { NumberInputComponent } from './number-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    imports: [FormsModule, ReactiveFormsModule, MatIconModule, CommonModule, MatInputModule],
    declarations: [NumberInputComponent],
    exports: [NumberInputComponent]
})
export class NumberInputModule {

}
